import { appPaths } from '../../../app.paths';

interface IList {
  id: string;
  name: string;
  dropdown: boolean;
  path: string;
  isMenuCollapsed: boolean;
  list?: { name: string; path: string }[];
  fragment?: string;
}

const list: IList[] = [
  {
    id: 'risk',
    name: 'Know your risk',
    dropdown: true,
    path: '/',
    isMenuCollapsed: true,
    list: [
      {
        name: 'What’s your type 1 diabetes risk?',
        path: appPaths.WHATSYOURTD1RISK,
      },
      {
        name: 'What is early-stage type 1 diabetes?',
        path: appPaths.WHATIST1D,
      },
    ],
  },
  {
    id: 'why-screen',
    name: 'Why screen?',
    dropdown: true,
    path: '/',
    isMenuCollapsed: true,
    list: [
      { name: 'The costs of not knowing', path: appPaths.COSTSNOTKNOWKING },
      { name: 'The benefits of knowing', path: appPaths.BENEFITSOFKNOWING },
      { name: 'The family history survey', path: appPaths.FAMILYHISTORY },
      // { name: 'Make a pledge', path: appPaths.MAKEAPLEDGE },
    ],
  },
  {
    id: 'how-screen',
    name: 'How to screen',
    dropdown: false,
    path: appPaths.HOWTOSCREEN,
    isMenuCollapsed: true,
  },
  {
    id: 'resources',
    name: 'Resources',
    dropdown: true,
    isMenuCollapsed: true,
    path: '/',
    list: [
      { name: 'Make a plan and FAQs', path: appPaths.USEFULTOOLS },
      { name: 'Sign up for updates', path: appPaths.SIGNUP },
    ],
  },
];

const spanishLinks: IList[] = [
  {
    id: 'factores-de-riesgo',
    name: 'Factores de riesgo de la diabetes tipo 1',
    dropdown: false,
    path: 'factores-de-riesgo',
    isMenuCollapsed: true,
    fragment: 't1d-risk-factors',
  },
  {
    id: 'prueba-de-deteccion',
    name: 'Hacerse la prueba de detección',
    dropdown: false,
    path: 'prueba-de-deteccion',
    isMenuCollapsed: true,
    fragment: 'getting-screened',
  },
  {
    id: 'haga-un-plan',
    name: 'Haga un plan',
    dropdown: false,
    path: 'haga-un-plan',
    isMenuCollapsed: true,
    fragment: 'haga-un-plan',
  },
];

const hcpLinks = [
  {
    name: 'Early detection matters',
    path: appPaths.EARLYDETECTION,
  },
  {
    name: 'T1D and family history',
    path: appPaths.T1DFAMILYHISTORY,
  },
  {
    name: 'HCP resources',
    path: appPaths.RESOURCE,
  },
];

export default list;
export { hcpLinks, spanishLinks };
